/* ============================================================
   RAYIE MUSK — MADE ON THE COAST
   Theme JS — Interactions & Animations
   ============================================================ */

(function () {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     CUSTOM CURSOR
  ─────────────────────────────────────────────────────────── */
  function initCursor() {
    const cursor = document.getElementById('cursor');
    if (!cursor) return;

    // Only on pointer (non-touch) devices
    if (!window.matchMedia('(pointer: fine)').matches) return;

    let mouseX = -100, mouseY = -100;
    let curX = -100, curY = -100;
    let raf;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    });

    document.addEventListener('mouseleave', () => {
      cursor.classList.add('is-hidden');
    });

    document.addEventListener('mouseenter', () => {
      cursor.classList.remove('is-hidden');
    });

    // Hover state on interactive elements
    const hoverTargets = 'a, button, [role="button"], input, select, textarea, label, .port-card, .product-card';
    document.addEventListener('mouseover', (e) => {
      if (e.target.closest(hoverTargets)) {
        cursor.classList.add('is-hovering');
      }
    });
    document.addEventListener('mouseout', (e) => {
      if (e.target.closest(hoverTargets)) {
        cursor.classList.remove('is-hovering');
      }
    });

    // Smooth follow with lerp
    function lerp(a, b, n) { return (1 - n) * a + n * b; }

    function animate() {
      curX = lerp(curX, mouseX, 0.14);
      curY = lerp(curY, mouseY, 0.14);
      cursor.style.left = curX + 'px';
      cursor.style.top  = curY + 'px';
      raf = requestAnimationFrame(animate);
    }

    raf = requestAnimationFrame(animate);
  }

  /* ──────────────────────────────────────────────────────────
     STICKY HEADER
  ─────────────────────────────────────────────────────────── */
function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let lastY = 0;
  const bgThreshold = 80;
  const delta = 10;

  function onScroll() {
    const y = window.scrollY;

    header.classList.toggle('is-scrolled', y > bgThreshold);

    if (y < bgThreshold) {
      header.classList.remove('is-hidden');
    } else if (y > lastY + delta) {
      header.classList.add('is-hidden');
    } else if (y < lastY - delta) {
      header.classList.remove('is-hidden');
    }

    lastY = y;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

  /* ──────────────────────────────────────────────────────────
     NAV OVERLAY
  ─────────────────────────────────────────────────────────── */
  function initNavOverlay() {
    const menuBtn = document.querySelector('.header-menu-btn');
    const overlay = document.getElementById('navOverlay');
    if (!menuBtn || !overlay) return;

    let isOpen = false;

    function open() {
      isOpen = true;
      menuBtn.classList.add('is-open');
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      menuBtn.setAttribute('aria-expanded', 'true');
    }

    function close() {
      isOpen = false;
      menuBtn.classList.remove('is-open');
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
      menuBtn.setAttribute('aria-expanded', 'false');
    }

    menuBtn.addEventListener('click', () => {
      const closeBtn = document.getElementById('navOverlayClose');
if (closeBtn) closeBtn.addEventListener('click', close);
      isOpen ? close() : open();
    });

    // Close on ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen) close();
    });

    // Close when a nav link is clicked
    overlay.querySelectorAll('.nav-overlay__link').forEach(link => {
      link.addEventListener('click', close);
    });
  }

  /* ──────────────────────────────────────────────────────────
     SCROLL ANIMATIONS (IntersectionObserver)
  ─────────────────────────────────────────────────────────── */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: show everything immediately
      document.querySelectorAll('.animate-up, .animate-fade').forEach(el => {
        el.classList.add('is-visible');
      });
      return;
    }

    const options = { threshold: 0.12, rootMargin: '0px 0px -40px 0px' };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // fire once
        }
      });
    }, options);

    document.querySelectorAll('.animate-up, .animate-fade').forEach(el => {
      observer.observe(el);
    });
  }

  /* ──────────────────────────────────────────────────────────
     HERO PARALLAX
  ─────────────────────────────────────────────────────────── */
  function initHeroParallax() {
    const heroMedia = document.querySelector('.hero-cinematic__media');
    if (!heroMedia) return;

    // Disable on mobile for performance
    if (window.matchMedia('(max-width: 768px)').matches) return;
    // Respect reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function onScroll() {
      const y = window.scrollY;
      heroMedia.style.transform = `translateY(${y * 0.28}px)`;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ──────────────────────────────────────────────────────────
     PDP STICKY CTA
  ─────────────────────────────────────────────────────────── */
  function initStickyPdpCta() {
    const stickyCta = document.querySelector('.pdp-sticky-cta');
    const atbBlock  = document.querySelector('.pdp-info__atb');
    if (!stickyCta || !atbBlock) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Show sticky bar when the real ATB button is NOT visible
        stickyCta.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0.1 });

    observer.observe(atbBlock);

    // Wire sticky CTA button to the real add-to-cart form
    const stickyBtn = stickyCta.querySelector('.pdp-sticky-cta__btn');
    const realForm  = document.querySelector('form[action="/cart/add"]');

    if (stickyBtn && realForm) {
      stickyBtn.addEventListener('click', () => {
        // Scroll to the main CTA smoothly
        atbBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  /* ──────────────────────────────────────────────────────────
     MARQUEE (duplicate content for seamless loop)
  ─────────────────────────────────────────────────────────── */
  function initMarquee() {
    const track = document.querySelector('.marquee-strip__track');
    if (!track) return;

    // The HTML already has two groups for seamless looping
    // Just ensure the animation is running
    track.style.willChange = 'transform';
  }

  /* ──────────────────────────────────────────────────────────
     VARIANT SELECTOR (PDP)
  ─────────────────────────────────────────────────────────── */
  function initVariantSelector() {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    const variantSelect = form.querySelector('select[name="id"]');
    if (!variantSelect) return;

    // Update price display when variant changes
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const priceEl = document.querySelector('.pdp-info__price');
      if (priceEl && option.dataset.price) {
        const price = parseInt(option.dataset.price, 10);
        priceEl.textContent = '£' + (price / 100).toFixed(2);
      }
    });
  }

  /* ──────────────────────────────────────────────────────────
     CART AJAX (Add to Bag without page reload on mobile)
  ─────────────────────────────────────────────────────────── */
  function initCartAjax() {
    const forms = document.querySelectorAll('form[action="/cart/add"]');
    forms.forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        const originalText = btn ? btn.textContent : '';

        try {
          if (btn) {
            btn.textContent = 'Adding...';
            btn.disabled = true;
          }

          const data = new FormData(form);
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: data
          });

          if (!response.ok) throw new Error('Failed to add to cart');

          // Update cart count
          const cartCount = await fetch('/cart.js').then(r => r.json());
          document.querySelectorAll('.site-header__cart-count').forEach(el => {
            el.textContent = cartCount.item_count;
            el.style.display = cartCount.item_count > 0 ? 'inline-flex' : 'none';
          });

          if (btn) {
            btn.textContent = 'Added ✓';
            setTimeout(() => {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 2000);
          }
        } catch (err) {
          if (btn) {
            btn.textContent = originalText;
            btn.disabled = false;
          }
          // Fallback: let the form submit normally
          form.submit();
        }
      });
    });
  }

  /* ──────────────────────────────────────────────────────────
     CART COUNT INIT
  ─────────────────────────────────────────────────────────── */
  async function initCartCount() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('.site-header__cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
    } catch (e) {
      // Silently fail — not critical
    }
  }

  /* ──────────────────────────────────────────────────────────
     SMOOTH SECTION ENTRANCE
     Stagger children of sections on load
  ─────────────────────────────────────────────────────────── */
  function initPageEntrance() {
    // Add animate-up to key elements that don't already have it
    const autoAnimate = [
      '.collection-header__eyebrow',
      '.collection-header__title',
      '.collection-header__subtitle',
      '.discovery-hero__eyebrow',
      '.discovery-hero__title',
      '.discovery-hero__body',
      '.story-hero__eyebrow',
      '.story-hero__title',
      '.story-hero__body',
    ];

    autoAnimate.forEach((selector, i) => {
      const el = document.querySelector(selector);
      if (el && !el.classList.contains('animate-up')) {
        el.classList.add('animate-up');
        if (i > 0) el.classList.add(`delay-${Math.min(i, 4)}`);
      }
    });
  }

  /* ──────────────────────────────────────────────────────────
     SCROLL BODY DATA ATTRIBUTE (for CSS hooks)
  ─────────────────────────────────────────────────────────── */
  function initScrollDataAttr() {
    function update() {
      document.body.setAttribute('data-scroll', Math.round(window.scrollY));
    }
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ──────────────────────────────────────────────────────────
     BOOT
  ─────────────────────────────────────────────────────────── */
  function boot() {
    initCursor();
    initStickyHeader();
    initNavOverlay();
    initScrollAnimations();
    initHeroParallax();
    initStickyPdpCta();
    initMarquee();
    initVariantSelector();
    initCartAjax();
    initCartCount();
    initPageEntrance();
    initScrollDataAttr();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
